module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      "m-detail-list" ]
  }, [(_vm.title) ? _c('h3', {
    staticClass: "h4"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('dl', {
    staticClass: "m-detail-list__field p"
  }, [_vm._l((_vm.items), function(definition, term, index) {
    return [_c('dt', {
      key: ("dt-" + index),
      staticClass: "m-detail-list__title fw-bold",
      domProps: {
        "innerHTML": _vm._s(term)
      }
    }), _vm._v(" "), _c('dd', {
      key: ("dd-" + index),
      staticClass: "m-detail-list__detail",
      domProps: {
        "innerHTML": _vm._s(definition || "…")
      }
    })]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6fef8eeb"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/DetailList.vue
// module id = 332
// module chunks = 0